import Axios from 'axios';
import config from '@/config/index';
import { message } from 'ant-design-vue';
import { AccountModule } from '@/store/modules/account';

export interface IUploadResponse {
  id: string;
  displayName: string;
  storedName: string;
  path: string;
}

const attachmentRequest = Axios.create({
  baseURL: config.baseUrl,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});
attachmentRequest.interceptors.request.use((requestConfig) => {
  if (AccountModule.token) {
    requestConfig.headers.Authorization = 'Bearer ' + AccountModule.token;
  }
  return requestConfig;
}, (error) => {
  return Promise.reject(error);
});
attachmentRequest.interceptors.response.use((response) => {
  return response.data;
}, (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      message.error('登录已失效');
      AccountModule.Logout();
      location.reload();
    }
  }
  return Promise.reject(error);
});

const uploadUrl = '/Attachment/upload';

export const upload = (form: FormData): Promise<IUploadResponse> => {
  return attachmentRequest.post(uploadUrl, form);
};
